export const DESKTOP_LINKS_ID = 'navigation-desktop-links' as const
